/* istanbul ignore file */

import Vue from "vue";

import toasted from "vue-toasted";

import store from "../store";
import directives from "../directives";
import { mapGetters } from "vuex";

import "../filters";
import "../axios";

import ShoppingCartButton from "../components/shopping-cart/ShoppingCartButton";
import ShoppingCartOverlay from "../components/shopping-cart/ShoppingCartOverlay";
import EssentialsCartOverlay from "../components/essentials/cart/EssentialsCartOverlay";
import EssentialsLists from "../components/essentials/Lists";
import EssentialsVendorFilterSelector from "../components/essentials/VendorFilter/Selector";
import EssentialsVendorFilterModal from "../components/essentials/VendorFilter/Modal";
import ProductTile from "../components/product-tiles/ProductTile";
import ProductNameFilterInput from "../components/campaigns/ProductNameFilterInput";
import ListWrapper from "../components/campaigns/ListWrapper";
import ProductTileWrapper from "../components/product-tiles/ProductTileWrapper";
import ReadMore from "../components/read-more/ReadMore";
import VendorList from "../components/vendor-list/VendorList";
import VendorTile from "../components/vendor-tiles/VendorTile";
import BadgeGroup from "../components/badges/BadgeGroup";
import Badge from "../components/badges/Badge";
import AdultContentWarning from "../components/adult-content-warning/AdultContentWarning";
import ShoppingList_Cart from "../components/shopping-list/StoreShoppingList_Cart";
import ShoppingList_Item from "../components/shopping-list/StoreShoppingList_Item";
import ShoppingListVisibilityWrapper from "../components/shopping-list/VisibilityWrapper";
import StoreJoinTabs from "../components/join-tabs/StoreJoinTabs";
import StoreJoinTab from "../components/join-tabs/StoreJoinTab";
import ShoppingListModalContent from "../components/shopping-list/ModalContent";
import MobileMenuToggle from "../components/mobile-menu/MobileMenuToggle";
import IconTeaser from "../components/icon-teaser/IconTeaser";
import ProductEssentialItem from "../components/product-tiles/ProductEssentialItem";
import MobileMenuContent from "../components/mobile-menu/MobileMenuContent";
import componentsCheckout from "../components/checkout/components-checkout";
import ServiceTile from "../components/tiles/ServiceTile";
import flashMessages from "../components/flashMessages";
import OtherVendorsModal from "../components/other-vendors-modal/OtherVendorsModal";
import VoucherCodeInput from "../components/checkout/VoucherCodeInput";
import Modal from "../components/Modal";
import PricingToggler from "../components/pricing-toggler/PricingToggler";
import CheckBoxCheckout from "../components/checkout/CheckBoxCheckout";
import ButtonCheckout from "../components/checkout/ButtonCheckout";
import ButtonCheckoutConfirm from "../components/checkout/ButtonCheckoutConfirm";
import StoreSwiper from "../components/swiper/StoreSwiper";
import FAQItem from "../components/faq-item/FAQItem";
import AsyncForm from "../components/forms/AsyncForm";
import CacheableForm from "../components/forms/CacheableForm";
import OnboardingSignupForm from "../components/onboarding/OnboardingSignupForm";
import OnboardingLoadingOverlay from "../components/onboarding/OnboardingLoadingOverlay";
import FormRecaptcha from "../components/recaptcha/FormRecaptcha";
import SocialSharing from "vue-social-sharing";

const vueEl = "[data-vue-global='frontend']";

Vue.directive("open-modal", directives.openModal);
Vue.directive("close-modal", directives.closeModal);

const currentCityElement = document.querySelector("[data-current-city]");
const currentLocaleElement = document.querySelector("[data-current-locale]");

document.ready.then(() => {
  Vue.use(toasted, {
    containerClass: "ata-toast",
    iconPack: "fontawesome",
    duration: 5000,
  });

  Vue.use(SocialSharing);

  if (document.querySelector(vueEl)) {
    if (currentCityElement) {
      store.dispatch("setCurrentCityUrl", currentCityElement.getAttribute("data-current-city"));
    }
    if (currentLocaleElement) {
      store.dispatch("setCurrentLocale", currentLocaleElement.getAttribute("data-current-locale"));
    }
    document.querySelectorAll(vueEl).forEach(element => {
      new Vue({
        el: element,
        store,
        name: "Frontend",
        components: {
          ...componentsCheckout,
          "shopping-cart-button": ShoppingCartButton,
          "shopping-cart-overlay": ShoppingCartOverlay,
          "read-more": ReadMore,
          "badge-group": BadgeGroup,
          badge: Badge,
          "vendor-list": VendorList,
          "vendor-tile": VendorTile,
          "essentials-cart-overlay": EssentialsCartOverlay,
          "essentials-lists": EssentialsLists,
          "essentials-vendor-filter-selector": EssentialsVendorFilterSelector,
          "essentials-vendor-filter-modal": EssentialsVendorFilterModal,
          "product-tile": ProductTile,
          "product-name-filter-input": ProductNameFilterInput,
          "list-wrapper": ListWrapper,
          "product-tile-wrapper": ProductTileWrapper,
          "store-shopping-list-cart": ShoppingList_Cart,
          "store-shopping-list-item": ShoppingList_Item,
          "shopping-list-modal-content": ShoppingListModalContent,
          "shopping-list-visibility-wrapper": ShoppingListVisibilityWrapper,
          "store-swiper": StoreSwiper,
          "flash-messages": flashMessages,
          "icon-teaser": IconTeaser,
          "product-essential-item": ProductEssentialItem,
          "pricing-toggler": PricingToggler,
          "adult-content-warning": AdultContentWarning,
          "mobile-menu-toggle": MobileMenuToggle,
          "mobile-menu-content": MobileMenuContent,
          "other-vendors-modal": OtherVendorsModal,
          "service-tile": ServiceTile,
          "voucher-code-input": VoucherCodeInput,
          "faq-item": FAQItem,
          "store-join-tabs": StoreJoinTabs,
          "store-join-tab": StoreJoinTab,
          modal: Modal,
          "check-box-checkout": CheckBoxCheckout,
          "button-checkout": ButtonCheckout,
          "button-checkout-confirm": ButtonCheckoutConfirm,
          "cacheable-form": CacheableForm,
          "async-form": AsyncForm,
          "onboarding-signup-form": OnboardingSignupForm,
          "onboarding-loading-overlay": OnboardingLoadingOverlay,
          "form-recaptcha": FormRecaptcha,
        },
        computed: {
          ...mapGetters({ toggles: "getGlobalToggles" }),
        },
        mounted() {
          window._lytics_.attachEventListeners(this.$el);
        },
      });
    });
  }
});
